import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'

import { RootState } from '../../../../store'

import { getBlockCategories } from './apiActions/getBlockCategories'
import { getBlockCategory } from './apiActions/getBlockCategory'
import { IBlockedCategory } from './IBlockedCategory'
import { initialBlockCategoryState } from './initialBlockCategoryState'

const blockCategoryAdapter = createEntityAdapter<IBlockedCategory>({
  // Assume IDs are stored in a field other than `blockedCategory.id`
  selectId: blockedCategory => blockedCategory.uuid,
  // Keep the "all IDs" array sorted based on category titles
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const blockCategorySlice = createSlice({
  name: 'blockCategory',
  initialState: blockCategoryAdapter.getInitialState(initialBlockCategoryState),
  reducers: {
    addOneBlockCategory: blockCategoryAdapter.addOne,
    updateOneBlockCategory: blockCategoryAdapter.updateOne,
  },
  extraReducers: builder => {
    builder.addCase(getBlockCategory.pending, state => ({
      ...state,
      status: 'loading',
    }))
    builder.addCase(getBlockCategory.rejected, (state, action) => ({
      ...state,
      status: 'failed',
      error: action.payload?.error || 'No Error',
    }))
    builder.addCase(getBlockCategory.fulfilled, (state, action) => {
      state.status = 'succeeded'
      blockCategoryAdapter.addOne(state, action.payload)
    })
    builder.addCase(getBlockCategories.pending, state => ({
      ...state,
      status: 'loading',
    }))
    builder.addCase(getBlockCategories.fulfilled, (state, action) => {
      state.status = 'succeeded'
      blockCategoryAdapter.addMany(state, action.payload.list)
    })
  },
})

export default blockCategorySlice.reducer

export const blockCategoryStateSelector = (state: RootState) =>
  state.blockCategory
export const blockCategoryAdaptorSelector = blockCategoryAdapter.getSelectors(
  (state: RootState) => state.blockCategory,
)
